import { useState, useRef, useEffect, useCallback } from 'react';
import { LIST_FOCUSABLE_ELEMENT_TYPE } from '~/modules/common/enums';

const useFocusListElementEffect = () => {
  const [focusableElementState, setFocusableElementState] = useState(null);

  const listRowElementRef = useRef(null);
  const fallbackElementRef = useRef(null);

  useEffect(() => {
    if (
      focusableElementState?.type ===
      LIST_FOCUSABLE_ELEMENT_TYPE.LIST_ROW_ELEMENT
    ) {
      listRowElementRef?.current.focus();
    } else if (
      focusableElementState?.type ===
      LIST_FOCUSABLE_ELEMENT_TYPE.FALLBACK_ELEMENT
    ) {
      fallbackElementRef?.current.focus();
    }
  }, [focusableElementState]);

  const getMatchingRowElementRef = useCallback(
    elementId =>
      focusableElementState?.type ===
        LIST_FOCUSABLE_ELEMENT_TYPE.LIST_ROW_ELEMENT &&
      focusableElementState?.id === elementId
        ? listRowElementRef
        : null,
    [focusableElementState, listRowElementRef]
  );

  const setNextFocus = useCallback(
    elementId =>
      setFocusableElementState(
        elementId
          ? {
              type: LIST_FOCUSABLE_ELEMENT_TYPE.LIST_ROW_ELEMENT,
              id: elementId
            }
          : { type: LIST_FOCUSABLE_ELEMENT_TYPE.FALLBACK_ELEMENT }
      ),
    []
  );

  return { fallbackElementRef, getMatchingRowElementRef, setNextFocus };
};

export default useFocusListElementEffect;
